module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/cover-640x360-07ffc633fd8407c5bae3fcea04b68fdb.webp";